import { AxiosRequest, BuildAxiosRequestHeaders } from "../Utils/Request/Axios";
import axios from "axios";

export async function getAccessToken() {
    try {
        axios
            .get("https://ochad.connecthealthworks.co.uk/api/public", {
                headers: {
                    appname: "PatientPortal",
                },
            })
            .then((result) => {
                //console.log(result.data)
                localStorage.setItem("access_token", result.data.access_token);
                localStorage.setItem("refresh_token", result.data.refresh_token);
                localStorage.setItem("expires_in", result.data.expires_in);
                localStorage.setItem("id_token", "public");
                return result.data.access_token;
            })
            .catch((error) => console.error(error));
    } catch (error) {
        console.error(error);
    }
}

export async function manageAppointment(appointmentUID, method) {
    var raw = JSON.stringify({
        requestJson: {
            AppointmentUID: appointmentUID,
        },
    });

    var requestOptions = BuildAxiosRequestHeaders(method, "AppointmentBooking");
    const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);
    // console.log(response);
    return response.data;
}

export async function fetchAppointment(appointmentUID, method) {
    var raw = JSON.stringify({
        requestJson: {
            AppointmentUID: appointmentUID,
        },
    });

    var requestOptions = BuildAxiosRequestHeaders(method, "AppointmentBooking");
    const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);
    // console.log(response);
    return response.data;
}

export async function getDistanceBetweenPostcodes(origin, destinations) {
    var raw = JSON.stringify({
        origin,
        destinations,
    });

    var requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
    };

    let response = await fetch(
        "https://ochad.connecthealthworks.co.uk/api/google/distanceBetweenPostcodes",
        requestOptions
    )
        .then((response) => response.json())
        .then((result) => {
            return result;
        })
        .catch((error) => console.log("error", error));

    return response;
}

export async function verifyReCaptcha(token, version) {
    var requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            captchaToken: token,
            tokenValidationType: "optInBooking",
            googleVersion: version,
        },
        redirect: "follow",
    };

    let response = await fetch("https://ochad.connecthealthworks.co.uk/api/google/captchaVerification", requestOptions)
        .then((response) => response.text())
        .then((result) => {
            return result;
        })
        .catch((error) => console.log("error", error));

    return response;
}

export async function getAppointmentBookingRequestPatient(dob, postcode, email, mobileNumber) {
    dob = new Date(dob);
    let day = dob.getDate() < 10 ? "0" + dob.getDate() : dob.getDate();
    let month = dob.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let year = dob.getFullYear();

    let formattedDob = `${year}-${month}-${day}`;

    //trim white spaces at either side of text
    postcode = postcode.trim();
    email = email.trim();
    mobileNumber = mobileNumber.trim().replace(/\s/g, "");

    let raw = JSON.stringify({
        requestJson: {
            DateOfBirth: formattedDob,
            Postcode: postcode,
            Email: email,
            MobileNumber: mobileNumber,
        },
    });
    raw = GetLightValidationBody(dob, postcode, email, mobileNumber);

    var requestOptions = BuildAxiosRequestHeaders("AppointmentBookingRequestInformation", "AppointmentBooking");
    try {
        const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);

        //if user found store info and return valid
        if (response.data.AppointmentBookingInformation) {
            let responseData = response.data.AppointmentBookingInformation;

            let apptTypes = [];
            if (responseData.IsFaceToFaceAppointment) apptTypes.push("Face to Face");
            if (responseData.IsTelephoneAppointment) apptTypes.push("Telephone");
            if (responseData.IsVirtualAppointment) apptTypes.push("Virtual");

            if (apptTypes.length == 0) {
                apptTypes = ["Face to Face", "Telephone", "Virtual"];
            }
            if (responseData.LastAppointmentDateTime == null) {
                return "error";
            }

            const lastApptDate = new Date(responseData.LastAppointmentDateTime);
            const diffInTime = new Date().getTime() - lastApptDate.getTime();
            const daysSinceLastAppt = Math.round(diffInTime / (1000 * 60 * 60 * 24));

            if (daysSinceLastAppt > 28) {
                return "expired";
            }

            localStorage.setItem(
                "patientInformation",
                JSON.stringify({
                    firstName: responseData.FirstName,
                    AppointmentBookingGUID: responseData.AppointmentBookingGUID,
                    appointmentTypes: apptTypes,
                    //TODO uncomment once location returned from API
                    // "location": responseData.location,
                    daysSinceLastApt: daysSinceLastAppt,
                    clinician: responseData.LastAppointmentClinician,
                })
            );

            return "valid";
        } else {
            switch (response.data.statusMessage) {
                case "Patient Information not found":
                    return "notFound";
                case "Appointment already requested":
                    return "alreadyRequested";
                default:
                    return "error";
            }
        }
    } catch (e) {
        return "error"; //no response
    }
}

export async function getCarePlanBase64Pdf(dob, postcode, email, mobileNumber, uuid) {
    let raw = GetLightValidationBody(dob, postcode, email, mobileNumber, uuid);

    var requestOptions = BuildAxiosRequestHeaders("validate", "CarePlan");
    try {
        const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);

        if (response.data.StatusCode === 200) {
            return { base64Pdf: [response.data.base64Pdf], firstName: [response.data.firstName] };
        } else {
            switch (response.data.statusMessage) {
                case "Care Plan not found":
                    return "notFound";
                default:
                    return "error";
            }
        }
    } catch (e) {
        return "error"; //no response
    }
}

export async function RequestAppointmentBooking(request) {
    var raw = JSON.stringify({
        requestJson: {
            request,
        },
    });

    var requestOptions = BuildAxiosRequestHeaders("AppointmentBookingRequest", "AppointmentBooking");
    const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);

    return response.data;
}

function GetLightValidationBody(dob, postcode, email, mobileNumber, uuid = null) {
    dob = new Date(dob);
    let day = dob.getDate() < 10 ? "0" + dob.getDate() : dob.getDate();
    let month = dob.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let year = dob.getFullYear();

    let formattedDob = `${year}-${month}-${day}`;

    //trim white spaces at either side of text
    postcode = postcode.trim();
    email = email.trim();
    mobileNumber = mobileNumber.trim().replace(/\s/g, "");

    var raw = JSON.stringify({
        requestJson: {
            DateOfBirth: formattedDob,
            Postcode: postcode,
            Email: email,
            MobileNumber: mobileNumber,
            UUID: uuid,
        },
    });

    return raw;
}

export async function RequestPatientQuestionnaireInfo(uuid) {
    var raw = JSON.stringify({
        requestJson: {
            results: [{ uuid: uuid }],
        },
    });

    var requestOptions = BuildAxiosRequestHeaders("GetPatientInfo", "QPortal");
    const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);

    return response.data.QInfo;
}

export async function RequestPatientSatisfactionLink(uuid) {
    var raw = JSON.stringify({
        requestJson: {
            results: [{ uuid: uuid }],
        },
    });

    var requestOptions = BuildAxiosRequestHeaders("GetPatientSatisfactionLink", "QPortal");
    const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);

    return response.data.satisfactionLink;
}

export async function GetQuestionnaireFaqs() {
    var raw = JSON.stringify({
        requestJson: {},
    });

    var requestOptions = BuildAxiosRequestHeaders("GetQuestionnaireFaq", "QPortal");
    const response = await AxiosRequest("https://connecthealth.azure-api.net/cher/api", raw, requestOptions);

    return response;
}
